module.exports = __webpack_public_path__ + "img/tb-logo-200x82.a5421a34.png";